module.exports = __webpack_public_path__ + "static/img/fuze-frozen.a847cf5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/integration/fuze-frozen.svg
// module id = fhfX
// module chunks = 134